import React, { useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Button,
  Space,
  message,
  Select,
} from 'antd';
import DepositApi from '../../../functions/api/booking/DepositApi';
import moment from 'moment';

const EditDepositModal = ({
  open,
  deposit,
  onClose,
  refresh,
  readOnly = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (deposit) {
      form.setFieldsValue({
        note: deposit?.note,
        refund_amount: deposit?.refund_amount,
        refund_method: deposit?.refund_method,
        refund_date: deposit?.refund_date ? moment(deposit.refund_date) : null,
        deposit_date: deposit?.deposit_date
          ? moment(deposit.deposit_date)
          : null,
      });
    }
  }, [deposit]);

  const onSave = async () => {
    if (readOnly) return onClose();
    const values = await form.validateFields();

    const payload = {
      note: values.note ?? '',
      status: Number(values.status || deposit.status),
      refund_amount: Number(values.refund_amount || 0),
      refund_method: Number(values.refund_method || 1),
      refund_date: values.refund_date
        ? moment(values.refund_date).toISOString()
        : moment().toISOString(),
    };

    const rs = await DepositApi.updateRefundStatus(deposit.id, payload);
    if (String(rs?.id) === String(deposit.id)) {
      message.success('✅ Lưu thành công');
      onClose();
      refresh();
    } else {
      message.error('❌ Lưu thất bại');
    }
  };

  return (
    <Modal
      open={open}
      title={
        readOnly
          ? `Chi tiết đặt cọc - ${deposit?.id || ''}`
          : `Sửa thông tin - ${deposit?.id || ''}`
      }
      onCancel={onClose}
      footer={null}
      centered
    >
      <Form form={form} layout="vertical">
        <Form.Item name="note" label="Ghi chú">
          <Input.TextArea rows={3} disabled={readOnly} />
        </Form.Item>

        <Form.Item name="status" label="Trạng thái">
          <Select
            disabled={readOnly}
            placeholder="Chọn trạng thái"
            options={[
              { label: 'Đã thu tiền', value: 3 },
              { label: 'Đã hoàn tiền', value: 4 },
              { label: 'Đã hủy giao dịch', value: 6 },
            ]}
          />
        </Form.Item>

        <Form.Item name="refund_amount" label="Số tiền hoàn">
          <Input type="number" placeholder="VD: 500000" disabled={readOnly} />
        </Form.Item>

        <Form.Item name="refund_method" label="Phương thức hoàn">
          <Select
            disabled={readOnly}
            placeholder="Chọn phương thức thanh toán"
            options={[
              { label: 'PAYPAL', value: 1 },
              { label: 'ONLINE', value: 2 },
            ]}
          />
        </Form.Item>
        <Form.Item name="refund_date" label="Ngày hoàn tiền">
          <DatePicker
            showTime
            format="DD/MM/YYYY HH:mm"
            disabled={readOnly}
            style={{ width: '100%' }}
            onChange={(value) => form.setFieldValue('refund_date', value)}
          />
        </Form.Item>
      </Form>

      <Space style={{ justifyContent: 'flex-end', width: '100%' }}>
        <Button onClick={onClose}>Đóng</Button>
        {!readOnly && (
          <Button type="primary" onClick={onSave}>
            Cập nhật
          </Button>
        )}
      </Space>
    </Modal>
  );
};

export default EditDepositModal;
